<template>
  <v-container fluid>
    <page-header @menuClick="chooseMenu" :menuItems="menuItems">
      <v-breadcrumbs>
        <v-breadcrumbs-item to="/secure/courses/management"
          >Course Management</v-breadcrumbs-item
        >
        <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
        <v-breadcrumbs-item :disabled="true">{{
          course ? course.name : "N/A"
        }}</v-breadcrumbs-item>
        <v-breadcrumbs-divider></v-breadcrumbs-divider>
        <v-chip color="green" text-color="white" v-if="course.status">{{
          course.status
        }}</v-chip>
      </v-breadcrumbs>

      <!-- <v-spacer></v-spacer>
      
      <v-btn
        v-if="course.calendarId"
        data-cy="coursecalendar"
        icon
        @click="editSchedule()"
        :disabled="isAppLoading"
      >
        <v-icon title="Schedules">mdi-calendar</v-icon>
      </v-btn> -->
    </page-header>

    <v-tabs show-arrows v-model="tab" icons-and-text>
      <v-tabs-slider></v-tabs-slider>

      <v-tab href="#tab-info">
        General Info
        <v-icon>mdi-information-outline</v-icon>
      </v-tab>
      <v-tab href="#tab-schedule">
        Schedule
        <v-icon>mdi-calendar-month-outline</v-icon>
      </v-tab>
      <v-tab href="#tab-people">
        People
        <v-icon>mdi-account-multiple-outline</v-icon>
      </v-tab>
      <v-tab href="#tab-topic">
        Topics ({{
          course && course.courseTopics ? course.courseTopics.length : 0
        }})
        <v-icon>mdi-bookmark-multiple-outline</v-icon>
      </v-tab>
      <v-tab href="#tab-material">
        Materials ({{
          course && course.courseMaterials ? course.courseMaterials.length : 0
        }})
        <v-icon>mdi-file-multiple-outline</v-icon>
      </v-tab>
      <v-tab href="#tab-communication">
        Communication Log
        <v-icon>mdi-notebook-outline</v-icon>
      </v-tab>

      <v-tabs-items class="ma-2" v-model="tab">
        <v-tab-item value="tab-info">
          <course-tab-info :course="course"/>
        </v-tab-item>
        <v-tab-item value="tab-schedule">
          <div class="d-flex flex-row-reverse mt-5">
            <choose-calendar
              v-if="course.googleCourseId"
              activatorLabel="Change Calendar"
              @selectedCalendar="changeCalendar"
            />
          </div>

          <course-calendar v-if="courseLoaded" :course="course" />

          <!-- <schedule-events
            :events.sync="events"
            :course.sync="course"
            :key="
              course.alternativeCalendarId
                ? course.alternativeCalendarId
                : course.calendarId
            "
          /> -->
          <schedule-plan
            v-if="course.courseTopics && course.courseTopics.length > 0"
            :course.sync="course"
          />
        </v-tab-item>
        <v-tab-item value="tab-people">
          <course-tab-people :course="course"/>
        </v-tab-item>
        <v-tab-item value="tab-topic">
          <course-tab-topics :course="course"/>
        </v-tab-item>
        <v-tab-item value="tab-material">
          <course-tab-materials class="mt-5" :course="course"/>
        </v-tab-item>
        <v-tab-item value="tab-communication">
          <communication-logs class="mt-5" :courseId="course.id" />
        </v-tab-item>
      </v-tabs-items>
    </v-tabs>

    <!-- <v-dialog
      v-model="navState.dialog"
      fullscreen
      transition="dialog-bottom-transition"
    >
      <v-toolbar>
        <v-btn data-cy="closedialog" icon @click="hideDialog()">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <course-schedule
        v-if="dialogMode === 'Course_Schedule'"
        :key="course.id"
        :course.sync="course"
        :events.sync="events"
      />
    </v-dialog> -->

    <v-dialog
      v-if="course.googleCourseId"
      v-model="syncDialog"
      scrollable
      :loading="isAppLoading"
      max-width="500"
    >
      <v-card>
        <v-card-title>
          Sync course with Google Classroom
          <v-btn icon class="ml-auto" @click="syncDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-select
            clearable
            chips
            deletable-chips
            label="Sync Fields"
            multiple
            v-model="syncRequestFields"
            :items="syncEntities"
            hint="Leave empty to sync all fields"
          ></v-select>
        </v-card-text>
        <v-card-actions>
          <v-btn
            title="Process materials preview images"
            @click="processMaterialsThumbnails"
            icon
          >
            <v-icon>mdi-image-move</v-icon>
          </v-btn>
          <v-spacer />
          <v-btn @click="syncCourse(course)" :disabled="isAppLoading"
            >Sync with Google Classroom</v-btn
          >
          <v-spacer />
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="cloneDialog" scrollable :loading="isAppLoading">
      <v-card>
        <v-card-title>
          Duplicate this course
          <v-btn icon class="ml-auto" @click="cloneDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text style="height: 300px">
          <v-text-field
            data-cy="newcoursename"
            v-model="cloneName"
            label="New course name"
          />
          <v-text-field
            v-model="cloneDescriptionHeader"
            label="New course description heading"
          />
          <v-textarea
            v-model="cloneDescription"
            rows="5"
            :row-height="5"
            auto-grow
            label="New course description"
          />
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn
            data-cy="createclone"
            color="blue darken-1"
            text
            @click="duplicateCourse(course)"
            :disabled="isAppLoading"
            >Create</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-if="course.courseOwner"
      v-model="ownerDialog"
      scrollable
      :loading="isAppLoading"
      max-width="350px"
    >
      <v-card>
        <v-card-title>
          Change course owner
          <v-btn icon class="ml-auto" @click="ownerDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-select
            v-model="newOwner"
            :items="availableOwners"
            item-text="name"
            item-value="email"
            label="Teachers"
            return-object
          />
        </v-card-text>
        <v-card-actions class="mx-auto">
          <v-btn @click="changeOwner" :disabled="isAppLoading">Update</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-if="!course.googleCourseId"
      v-model="newGoogleClassroomDialog"
      scrollable
      :loading="isAppLoading"
      max-width="600"
    >
      <v-card>
        <v-card-title>
          Create Google Classroom
          <v-btn icon class="ml-auto" @click="ownerDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          Choose the owner of the new Google Classroom
          <v-select
            v-model="newOwner"
            :items="availableOwners"
            item-text="name"
            item-value="email"
            label="Course Owner"
            return-object
          />
        </v-card-text>
        <v-card-actions class="mx-auto">
          <v-btn @click="createGoogleClassroom" :disabled="isAppLoading"
            >Create Classroom</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import moment from "moment";

const CourseTabInfo = () => import("@/components/course/CourseTabInfo.vue");
const CourseTabPeople = () => import("@/components/course/CourseTabPeople.vue");
const CourseTabTopics = () => import("@/components/course/CourseTabTopics.vue");
const CourseTabMaterials = () => import("@/components/course/CourseTabMaterials.vue");
const CourseCalendar = () => import("@/components/course/CourseCalendar.vue");
// const CourseSchedule = () => import("@/components/course/CourseSchedule.vue");
// const ScheduleEvents = () => import("@/components/course/ScheduleEvents.vue");
const SchedulePlan = () => import("@/components/course/SchedulePlan.vue");
const CommunicationLogs = () =>
  import("@/components/course/CommunicationLogs.vue");
const ChooseCalendar = () => import("@/components/course/ChooseCalendar.vue");

const PageHeader = () => import("@/components/common/PageHeader.vue");

export default {
  data() {
    return {
      tab: null,
      loading: true,
      previewResource: false,
      pdfSrc: "",
      drag: false,
      course: {},
      courseLoaded: false,
      dialogMode: null,
      syncDialog: false,
      cloneDialog: false,
      ownerDialog: false,
      newGoogleClassroomDialog: false,
      cloneName: null,
      cloneDescription: null,
      cloneDescriptionHeader: null,
      syncEntities: [
        "COURSEOWNER",
        "COURSE",
        "TOPIC",
        "TEACHER",
        "STUDENT",
        "INVITATION",
        "RP",
        "COURSEWORK",
        "COURSESCHEDULE",
        "STANDARD",
        "COURSE_MATERIALS",
      ],
      syncRequestFields: [
        "COURSEOWNER",
        "COURSE",
        "TOPIC",
        "TEACHER",
        "STUDENT",
      ],
      events: [],
      availableOwners: [],
      newOwner: null,
      activeTopic: null,
    };
  },
  mounted() {
    this.tab = this.$route.params.tab ? this.$route.params.tab : "tab-info";
  },
  computed: {
    ...mapGetters(["navState", "isAppLoading"]),
    courseLastUpdateTime() {
      return moment(this.course.courseLastUpdateTime).format(
        "ddd MMM DD, YYYY hh:mm a"
      );
    },
    lastSyncTime() {
      return moment(this.course.lastSyncTime).format(
        "ddd MMM DD, YYYY hh:mm a"
      );
    },
    simpleCourse() {
      return { id: this.course.id, name: this.course.name };
    },
    flatCourse() {
      return {
        id: this.course.id,
        name: this.course.name,
        grade: this.course.grade,
        subject: this.course.subject,
      };
    },
    menuItems() {
      let menu = [
        {
          id: "edit-info",
          text: "Edit Course Info",
          icon: "mdi-account-outline",
          to: {
            name: "CourseInfo",
            params: { courseId: this.$route.params.id },
          },
        },
        {
          id: "add-schedule",
          text: "Add Schedule",
          icon: "mdi-calendar-outline",
          to: {
            name: "CourseSchedule",
            params: { courseId: this.$route.params.id },
          },
        },
        // {
        //   id: "add-student",
        //   text: "Enroll Student",
        //   icon: "mdi-account-star-outline",
        //   to: {
        //     name: "CourseStudent",
        //     params: { courseId: this.$route.params.id },
        //   },
        // },
        {
          id: "clone-course",
          text: "Clone Course",
          icon: "mdi-content-duplicate",
          disabled: true,
        },
        {
          id: "delete-course",
          text: "Delete Course",
          icon: "mdi-delete-outline",
        },
      ];

      if (this.course.googleCourseId) {
        if (this.course.courseState != "ARCHIVED") {
          menu.push({
            id: "archive-course",
            text: "Archive Course",
            icon: "mdi-archive-arrow-down-outline",
            googleClassoom: true,
          });
        }
        menu.push({
          id: "sync-google-classroom",
          text: "Sync Google Classroom",
          icon: "mdi-cloud-sync-outline",
          googleClassoom: true,
          disabled: true,
        });
        menu.push({
          id: "change-classroom-owner",
          text: "Change Classroom Owner",
          icon: "mdi-account-edit-outline",
          googleClassoom: true,
        });
      } else {
        menu.push({
          id: "create-google-classroom",
          text: "Create Google Classroom",
          icon: "mdi-plus-box-multiple-outline",
        });
      }

      if (this.course && this.course.courseState == "ARCHIVED") {
        menu.push({
          id: "unarchive-course",
          text: "Unarchive Course",
          icon: "mdi-archive-arrow-up-outline",
          googleClassoom: true,
        });
      }
      return menu;
    },
  },
  watch: {
    course(obj) {
      if (obj) {
        this.cloneName = obj.name;
        this.cloneDescription = obj.description;
        this.cloneDescriptionHeader = obj.descriptionHeading;
      }
    },
  },
  components: {
    // CourseSchedule,
    // ScheduleEvents,
    CommunicationLogs,
    SchedulePlan,
    ChooseCalendar,
    PageHeader,
    CourseCalendar,
    CourseTabInfo,
    CourseTabPeople,
    CourseTabTopics,
    CourseTabMaterials
  },
  methods: {
    ...mapActions([
      "showDialog",
      "hideDialog",
      "addErrorMessage",
      "addMessage",
      "addSuccessMessage",
      "removeCourse",
    ]),
    async initCourse() {
      const result = await this.$axios
        .get("classroom/course", {
          params: { courseId: this.$route.params.id },
        })
        .then((resp) => {
          this.loading = false;
          this.course = resp.data;
          this.courseLoaded = true;

          if (this.course.calendarId) {
            this.pullCourseEvents()
              .then((events) => {
                this.events = events;
              })
              .catch((error) => {
                console.log(error);
              });
          }

          //Sync course if course owner is empty
          if (!this.course.courseOwner && this.course.googleCourseId) {
            const syncFields = ["COURSEOWNER"];
            this.syncCourse(this.course, syncFields);
          }
        })
        .catch(() => {
          this.addErrorMessage("Error loading course from server");
        });

      return result;
    },
    createGoogleClassroom() {
      const params = {
        courseId: this.course.id,
        courseOwner: this.newOwner.email,
      };
      this.$axios
        .post("/course/google/classroom/push", null, { params })
        .then((resp) => {
          this.course = resp.data;
        })
        .catch((error) => {
          this.addErrorMessage(error.message);
        });
    },
    loadOwners() {
      this.$axios
        .get("/account/gsuite-accounts")
        .then((resp) => {
          const gSuiteAccounts = resp.data;
          this.availableOwners = gSuiteAccounts.map((acct) => {
            return {
              name: `${acct.email} (${acct.firstName} ${acct.lastName})`,
              email: acct.email,
            };
          });
        })
        .catch((error) => {
          console.log(error);
        });
    },
    changeOwner() {
      let requestBody = Object.assign({}, this.course);
      requestBody.courseOwner = {
        email: requestBody.courseOwner.email,
        id: requestBody.courseOwner.id,
      };
      const params = { newOwnerId: this.newOwner.email };
      this.$axios
        .post("/classroom/course/change/owner", requestBody, {
          params,
        })
        .then((resp) => {
          const respOwner = resp.data;
          // console.log(respOwner);
          this.course.courseOwnerId = respOwner.id;
          this.course.courseOwner = respOwner;

          this.ownerDialog = false;
        })
        .catch((resp) => {
          this.addErrorMessage(resp.data.message || resp.data);
        });
    },
    archiveCourse(course) {
      if (confirm("Please confirm you want to archive this course")) {
        let requestBody = Object.assign({}, course);
        requestBody.courseOwner = {
          email: requestBody.courseOwner.email,
          id: requestBody.courseOwner.id,
        };
        this.$axios
          .post("/classroom/course/archive", requestBody)
          .then((resp) => {
            const deletedCourseId = resp.data;
            const course = { googleCourseId: deletedCourseId };
            const message = `Course archived ${course.googleCourseId}`;
            this.course.courseState = "ARCHIVED";
            this.addSuccessMessage(message);
          })
          .catch((resp) => {
            this.addErrorMessage(resp.data.message);
          });
      }
    },
    unArchiveCourse() {
      if (confirm("Would you like to restore this Course?")) {
        let requestBody = Object.assign({}, this.course);
        requestBody.courseOwner = {
          email: requestBody.courseOwner.email,
          id: requestBody.courseOwner.id,
        };
        this.$axios
          .post("/classroom/course/unarchive", requestBody)
          .then((resp) => {
            const courseId = resp.data;
            const message = `Course restored: ${courseId}`;
            this.course.courseState = "ACTIVE";
            this.addSuccessMessage(message);
          })
          .catch((resp) => {
            this.addErrorMessage(resp.data.message);
          });
      }
    },
    deleteCourse(course) {
      const courseName = course.name;
      let requestBody = { id: this.course.id };

      this.$axios
        .post("/course/delete", requestBody)
        .then((resp) => {
          const deletedCourseId = resp.data;
          const message = `Successfully deleted ${courseName} (${deletedCourseId})`;
          this.removeCourse(course);
          this.course = null;
          this.addSuccessMessage(message);
          this.$router.push({ name: "CourseManagement" });
        })
        .catch((resp) => {
          this.addErrorMessage(resp.data.message || resp.data);
        });
    },
    duplicateCourse(course) {
      let requestBody = Object.assign({}, course);
      requestBody.courseOwner = {
        email: requestBody.courseOwner.email,
        id: requestBody.courseOwner.id,
      };
      requestBody.name = this.cloneName;
      requestBody.descriptionHeading = this.cloneDescriptionHeader;
      requestBody.description = this.cloneDescription;
      const params = { newOwner: "teacher@sylvannyc.com" };
      this.$axios
        .post("/course/duplicate", requestBody, { params })
        .then((resp) => {
          this.cloneDialog = false;
          const duplicatedcourse = resp.data;
          const message = `Duplicated Course ${course.name}`;
          this.addSuccessMessage(message);
          this.$router.push({
            name: "CourseDetail",
            params: { id: duplicatedcourse.id },
          });
        })
        .catch(() => {
          this.addErrorMessage("Error duplicating course, try again later");
        });
    },
    syncCourse(course, syncFields) {
      const data = {
        googleCourseIds: [course.googleCourseId],
        requestFields: syncFields || this.syncRequestFields,
      };
      this.$axios
        .post("/classroom/syncCourses", data)
        .then((resp) => {
          const updatedCourse = resp.data[0];
          console.log(updatedCourse);
          this.course = Object.assign({}, updatedCourse);

          const message = `Synced Course ${course.name} with Google Classroom`;
          this.addSuccessMessage(message);
        })
        .catch(() => {
          this.addErrorMessage("Error syncing with Google server");
        });
    },
    processMaterialsThumbnails() {
      const params = { courseId: this.course.id };
      this.$axios
        .get("/course/processMaterials", {
          params,
        })
        .catch((error) => {
          this.addErrorMessage(error.message);
        });
    },
    // getTopicCourseWorks(topicId) {
    //   const topicCourseWorks = this.course.courseWorks.filter(
    //     (w) => w.topicId == topicId
    //   );
    //   if (topicCourseWorks && topicCourseWorks.length > 0) {
    //     return topicCourseWorks;
    //   } else {
    //     return null;
    //   }
    // },
    invitation() {
      this.dialogMode = "Course_Invitation";
      this.showDialog();
    },
    // editSchedule() {
    //   this.dialogMode = "Course_Schedule";
    //   this.showDialog();
    // },
    pullCourseEvents() {
      return new Promise((resolve, reject) => {
        const params = {
          courseId: this.course.id,
        };
        this.$axios
          .get("/classroom/course/events", { params })
          .then((resp) => {
            resolve(resp.data);
          })
          .catch((err) => {
            this.addErrorMessage("Error retrieving calendar events");
            reject(err);
          });
      });
    },
    chooseMenu(event, menu) {
      if (menu.id == "sync-google-classroom") {
        this.syncDialog = true;
      } else if (menu.id == "clone-course") {
        this.cloneDialog = true;
      } else if (menu.id == "delete-course") {
        this.deleteCourse(this.course);
      } else if (menu.id == "archive-course") {
        this.archiveCourse(this.course);
      } else if (menu.id == "unarchive-course") {
        this.unArchiveCourse(this.course);
      } else if (menu.id == "create-google-classroom") {
        this.newGoogleClassroomDialog = true;
      }
    },
    changeCalendar(srcCourse) {
      //change calendar to the same calendar for srcCourse
      console.log("change calendar to the same calendar for srcCourse");
      console.log(srcCourse);
      const params = {
        courseId: this.course.id,
        alt_google_calendar_id: srcCourse.calendarId,
      };
      this.$axios
        .post("/course/calendar/change", null, { params })
        .then((resp) => {
          this.course = resp.data;
          this.pullCourseEvents()
            .then((events) => {
              this.events = events;
            })
            .catch((error) => {
              console.log(error);
            });
        })
        .catch((error) => {
          this.addErrorMessage(error.message);
        });
    },
  },
  created() {
    this.initCourse();
    this.loadOwners();
  },
};
</script>

<style>
</style>